import { useSelector, useDispatch } from 'react-redux';
import Header from '../Header';
import Limits from './Limits';
import Tolerance from './Tolerance';
import Times from './Times';
import { updateDaysLimits } from 'http/components/SettingService';
import { HandleLoading } from 'Utils/Helpers/HandleLoading';
import { SetDaysLimits } from 'Utils/Helpers/HandleApiData';

const title = 'زمان‌ها';

export default function SetDayLimit() {
  const dispatch = useDispatch();
  const { extraCount, weeklyLimit, totalTimes } = useSelector((state) => ({
    extraCount: state.setting.extraCount,
    weeklyLimit: state.setting.weeklyLimit,
    totalTimes: state.setting.totalTimes,
  }));

  const onFinish = async () => {
    dispatch(HandleLoading(true));
    const response = await updateDaysLimits(weeklyLimit, +extraCount, totalTimes);
    if(response.status) {
      await dispatch(SetDaysLimits(response.data))
    } else {
      dispatch(HandleLoading(false));
    }
  }

  return (
    <>
      <Header title={title} onClick={onFinish}/>
      <Limits weeklyLimit={weeklyLimit} />
      <Tolerance extraCount={extraCount} />
      <Times totalTimes={totalTimes} />
   </>
  );
}